export const ContactRegistrationTypes = {
  ContractRegistration: '0',
  AddingContact: '1'
};
